module.exports = __webpack_public_path__ + "img/Mat.fbe58542.png";